export default __webpack_public_path__ + "static/media/settings.82ab6cbe.svg";